/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/**
 * User: risto
 * Date: 4/8/14
 */
(function ($) {
    "use strict";
    /*globals Tc, doT, SCS, debug */
    /*jshint smarttabs:false */

    Tc.Module.Newsitem = Tc.Module.extend({

        on: function (callback) {

            var mod = this,
                $ctx = mod.$ctx;

            $('.js-side .textbox', $ctx).hover(
                function () {
                    var imgWidth = $ctx.find('img').width();
                    var width = Math.min(180, imgWidth);
                    if (!scent.global.isMobile()) {
                        $(this).animate({
                            marginLeft: "-=" + width + "px",
                            width: "+=" + width + "px"
                        }, 500);
                        $(this).find('div.lauftext').fadeIn();
                    }
                },
                function () {
                    if (!scent.global.isMobile()) {
                        var imgWidth = $ctx.find('img').width();
                        var width = Math.min(180, imgWidth);
                        $(this).animate({
                            marginLeft: "+=" + width + "px",
                            width: "-=" + width + "px"
                        }, 500);
                        $(this).find('div.lauftext').fadeOut();
                    }
                }
            );

            $('.js-bottom .textbox', $ctx).hover(
                function () {
                    var imgHeight = $ctx.find('img').height();
                    var height = Math.min(180, imgHeight);
                    if (!scent.global.isMobile()) {
                        $(this).stop().animate({
                            marginTop: "-" + (height + 5) + "px",
                            height: (height + 140) + "px"
                        }, 500);
                        $(this).find('div.lauftext').fadeIn();
                    }
                    $('.js-bottom .textbox .content h2').trigger("update");
                },
                function () {
                    var imgHeight = $ctx.find('img').height();
                    var height = Math.min(180, imgHeight);
                    if (!scent.global.isMobile()) {
                        $(this).stop().animate({
                            marginTop: "-" + 5 + "px",
                            height: 140 + "px"
                        }, 500, function () {
                            $(this).clearQueue()
                        });
                        $(this).find('div.lauftext').fadeOut();
                    }
                    $('.js-bottom .textbox .content h2').trigger("update");
                }
            );

    		callback();
        }
    });
}(Tc.$));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.Newsitem.js
// module id = 42
// module chunks = 0